import React from 'react';
export function Footer() {
  return <footer className="w-full bg-paper px-5 py-10" data-id="element-86" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-87" data-mp="3gfsoch60l2p3">
        <p className="font-serif-display text-base font-semibold text-ink" data-id="element-88" data-mp="3ghc3u5juj9pt">
          Visual Chemistry Master System™
        </p>
        <p className="mt-2 text-xs leading-relaxed text-ink/50" data-id="element-89" data-mp="36p6dt1d5n2d9">
          The complete visual Chemistry teaching system for High School teachers worldwide. Instant
          download · One-time payment · 30-day guarantee.
        </p>
        <p className="mt-4 text-xs text-ink/40" data-id="element-90" data-mp="37o6qw57hzdw">
          © 2026 Visual Chemistry Master System™ by THE RESOURCE LAB. All rights reserved.
        </p>
      </div>
    </footer>;
}